module.exports = __webpack_public_path__ + "img/Logo-USFS@2x.3e585615.png";